<template>
  <Track v-bind=track :hasMultipleEditions="hasMultipleEditions" :class="{'o-playlist--highlight' : currentTrack}" :data-hitlist-selector-code="track.selectorCode">
    <PreviewTrack :url="track.hooks.m4a" v-if="track.hooks.m4a" />
    <Like :selectorCode="track.selectorCode" />
    <TrackActionSheet :hooks="track.hooks" />
  </Track>
</template>

<script>
import Track from './Track';
import Like from '../like/Like';
import PreviewTrack from '../tracks/PreviewTrack';
import TrackActionSheet from '../tracks/TrackActionSheet';
import { mapGetters } from 'vuex';

export default {
  name: 'TrackListTrack',
  props: ['track'],
  components: {
    Like,
    TrackActionSheet,
    PreviewTrack,
    Track
  },
  computed: {
    ...mapGetters('hitlist', ['liveTrack', 'hasMultipleEditions']),
    currentTrack() {
      return this.liveTrack && this.liveTrack.selector_code == this.track.selectorCode
    }
  }
}
</script>